import { at } from './indexed';
import { WEEKDAYS, type Weekday } from './vocab';

const DAY_MS = 86_400_000;

export function addDays(date: string, n: number): string {
  const ms = Date.parse(`${date}T00:00:00Z`) + n * DAY_MS;
  return new Date(ms).toISOString().slice(0, 10);
}

export function daysBetween(from: string, to: string): number {
  return Math.round((Date.parse(`${to}T00:00:00Z`) - Date.parse(`${from}T00:00:00Z`)) / DAY_MS);
}

export function toLocalDate(instant: Date, timeZone: string): string {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(instant);
  const { year, month, day } = Object.fromEntries(parts.map((p) => [p.type, p.value]));
  return `${year}-${month}-${day}`;
}

// Monday, like Postgres date_trunc('week', …), which @painpal/db weeklyZoneSeconds groups by.
export function weekStart(localDate: string): string {
  const weekday = new Date(`${localDate}T00:00:00Z`).getUTCDay();
  return addDays(localDate, -((weekday + 6) % 7));
}

export const weekEnd = (start: string): string => addDays(start, 6);

export const isWeekStart = (date: string): boolean => weekStart(date) === date;

export const weekdayOf = (localDate: string): Weekday => at(WEEKDAYS, (new Date(`${localDate}T00:00:00Z`).getUTCDay() + 6) % 7);
